<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="400"
        app
        temporary
        right
        class="wost-drawer"
    >
        <div class="navigation-head">
            <span>{{ titleForm }}</span>                         
        </div>
        <div class="pl-3 pt-3 pr-3" style="height: 80vh;">
            <template>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            ref="name"
                            v-model="roleForm.name" 
                            label="Nombre" 
                            outlined 
                            :rules="[() => !!roleForm.name || 'Es necesario ingresar un nombre']"
                            hide-details="auto"
                            required
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-textarea
                            v-model="roleForm.description"
                            outlined
                            label="Descripción"
                            rows="2"
                            hide-details
                            >
                        </v-textarea>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-card>
                            <v-card-title class="pt-2 pb-2">
                                Lista de permisos
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text class="permissions-list">
                                <v-treeview
                                    selectable
                                    selected-color="blue"
                                    :items="permissions_list"
                                    open-on-click
                                    v-model="roleForm.permissions"
                                ></v-treeview>
                            </v-card-text>
                        </v-card>                        
                    </v-col>
                </v-row>                
            </template>
        </div>

        <div class="mt-2 pl-3 pt-2 pr-3">
            <template>
                <v-row>
                    <v-col cols="6" class="pt-3 pb-3">
                        <v-btn block height="40" dark color="red" @click="handleCancel">
                            <v-icon class="mr-1" size="16">far fa-times-circle</v-icon>
                            Cancelar
                        </v-btn>
                    </v-col>
                    <v-col cols="6" class="pt-3 pb-3">
                        <v-btn v-if="action == 'create'" dark color="success" block height="40" @click="handleStore">
                            <v-icon class="mr-1" size="16">far fa-save</v-icon>
                            Guardar
                        </v-btn>
                        <v-btn v-if="action == 'update'" dark color="success" block height="40" @click="handleUpdate">
                            <v-icon class="mr-1" size="16">far fa-save</v-icon>
                            Actualizar
                        </v-btn>
                    </v-col>
                </v-row>
            </template>
        </div>
    </v-navigation-drawer>
</template>

<script>
import {mapState, mapActions} from 'vuex';

export default {
    name: 'CreateUpdate',
    data() {
        return {
            drawer: false,
            titleForm: null,
            action: null,
            roleForm: {
                id: null,
                name: null, 
                description: null,
                permissions: []
            }
        }
    },
    computed: {
        ...mapState('roles', [
            'permissions_list'
        ])
    },
    methods: {
        ...mapActions('roles', [
            'getPermissionsList',
            'store',
            'update'
        ]),
        showForm(title, action, role = null) {
            this.clearData();
            this.titleForm = title;
            this.action = action;
            if (role) {
                this.setRole(role);
            }
            this.drawer = !this.drawer;
        },
        clearData() {
            this.titleForm = null;
            this.action = null;
            this.roleForm.id = null;
            this.roleForm.name = null;
            this.roleForm.description = null;
            this.roleForm.permissions = [];
            this.clearErrors();
        },
        closeForm() {
            this.clearData()
            this.drawer = false
        },
        setRole(role){
            this.roleForm.id = role.id;
            this.roleForm.name = role.name;
            this.roleForm.description = role.description;
            if (role.permission_codes) {
                this.roleForm.permissions = role.permission_codes;
            } else {
                this.roleForm.permissions = [];
            }            
        },
        handleCancel() {
            this.closeForm();
        },
        async handleStore() {
            if (!this.existErrors()) {
                await this.store(this.roleForm)
                this.closeForm()
            }            
        },
        async handleUpdate() {
            if (!this.existErrors()) {
                await this.update(this.roleForm)
                this.closeForm()
            }            
        },
        existErrors(){
            let hasErrors = false;

            Object.keys(this.roleForm).forEach(f => {                
                if (this.$refs[f]) {
                    if (!this.roleForm[f]) hasErrors = true
                    this.$refs[f].validate(true);
                }                
            });

            return hasErrors;
        },
        clearErrors() {
            Object.keys(this.roleForm).forEach(f => {
                if (this.$refs[f]) this.$refs[f].reset()                
            });
        },
    },
    created() {
        this.getPermissionsList();
    }
}
</script>

<style scoped>
.permissions-list{
    height: 50vh;
    overflow-y: auto;
}
</style>